import { compact, map } from "lodash";
import { ClientGetRoomListResponse } from "../../proto/ClientGetRoomList_pb";
import store from "../../store";
import { addRoomMessages } from "../../store/messages/actions";
import { addRooms, updateFetchRoomCompleted, updateRoomStatus } from "../../store/rooms/actions";
import { addUsers } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";
import { IDraftStateType } from "../../store/draft/types";
import { setDrafts } from "../../store/draft/actions";

export default class HandleClientGetRoomListResponse extends BaseHandler<ClientGetRoomListResponse> {
  handle() {
    const clientGetRoomListResponse = this.response.toObject();
    if (clientGetRoomListResponse.roomsList.length === 0) {
      store.dispatch(updateFetchRoomCompleted(true));
    }
    store.dispatch(addRooms(clientGetRoomListResponse.roomsList));
    store.dispatch(addUsers(compact(map(clientGetRoomListResponse.roomsList, "chatRoomExtra.peer"))));
    store.dispatch(updateRoomStatus("resolved"));

    /*
     * {[roomId] : draft}
     * */
    if (clientGetRoomListResponse.roomsList) {
      const roomsDraft: IDraftStateType = {};

      clientGetRoomListResponse.roomsList.forEach((room) => {
        if (room.draft) {
          roomsDraft[room.id] = room.draft;
        }
        //  object[room.id] = room.draft
        const message = room.firstUnreadMessage || room.lastMessage;
        if (message !== undefined) {
          store.dispatch(
            addRoomMessages({
              roomId: room.id,
              messageList: [message],
            })
          );
        }
      });
      store.dispatch(setDrafts(roomsDraft));
      // store dispatch object
    }
  }
}
